import React, { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { Link, NavLink, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import {
  timeSince,
  TOAST_DURATION,
  TOAST_ERROR_COLOR,
  TOAST_POSITION,
  TOAST_SUCCESS_COLOR,
} from "../../common/app_constant";
import { ENV, SUB_DIRECTORY } from "../../common/constant";
import {
  actionClientList,
  resetClientListResponse,
} from "../../routes/app/auth/my_profile/store";
import {
  actionLatestNotification,
  resetLatestNotification,
} from "../../routes/app/auth/notifications/store";
import {
  actionLogout,
  resetLogout,
} from "../../routes/app/auth/notifications/store";
import { actionAdminLogout, actionEmployeeLogout, actionEmployerLogout, resetAdminLogoutResponse, resetEmployeeLogoutResponse, resetEmployerLogoutResponse } from "../../routes/app/public/store";

const Header = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const logo = ENV === 'development' ? `${SUB_DIRECTORY}/assets/images/logo-pinc.png` : `${SUB_DIRECTORY}/assets/images/Axis_Bank-Logo.png`
  const location = useLocation();

  var route = location.pathname;

  const { clientList } = useSelector((state) => ({
    ...state.MyProfileStore,
  }));

  const { latestNotification } = useSelector((state) => ({
    ...state.NotificationStore,
  }));

  const { logout } = useSelector((state) => ({
    ...state.NotificationStore,
  }));

  const { AdminLogout, EmployerLogout, EmployeeLogout } = useSelector((state) => ({
    ...state.publicStore,
  }));


  const [clientListArr, setClientList] = useState([]);
  const [latestNotificationList, setLatestNotification] = useState(null);
  const [user, setUserObj] = useState(null);
  const [employer, setEmployer] = useState(null);
  const [userName, setUserName] = useState(null);
  useEffect(() => {
    let user = JSON.parse(localStorage.getItem("userData"));
    let Employer = localStorage.getItem("next");
    setEmployer(Employer);
    if (user !== null) {
      setUserName(user.full_name);
      let userObj = JSON.stringify(user);
      if (userObj !== null && userObj.length > 0) {
        setUserObj(userObj);
      }
    }
  }, [user]);

  useEffect(() => {
    if (user != null) {
      // dispatch(actionClientList());
      // dispatch(actionLatestNotification());
    }
  }, [user]);

  useEffect(() => {
    if (clientList !== null) {
      dispatch(resetClientListResponse());
      if (clientList.result === true) {
        setClientList(clientList.response);
      } else {
        switch (clientList.status_code) {
          case 401:
            toast.error(clientList.message, {
              duration: TOAST_DURATION,
              position: TOAST_POSITION,
              style: {
                color: TOAST_ERROR_COLOR,
              },
            });
            localStorage.clear();
            navigate("/login", { replace: true });
            break;
          default:
        }
      }
    }
  }, [clientList]);

  useEffect(() => {
    if (latestNotification !== null) {
      dispatch(resetLatestNotification());
      if (latestNotification.result === true) {
        setLatestNotification(latestNotification.response);
      } else {
        switch (latestNotification.status_code) {
          case 401:
            toast.error(latestNotification.message, {
              duration: TOAST_DURATION,
              position: TOAST_POSITION,
              style: {
                color: TOAST_ERROR_COLOR,
              },
            });
            localStorage.clear();
            navigate("/login", { replace: true });
            break;
          default:
        }
      }
    }
  }, [latestNotification]);

  useEffect(() => {
    if (logout !== null) {
      dispatch(resetLogout());
      if (logout.result === true) {
        localStorage.clear();
        navigate("/login", { replace: true });
        toast.success(logout.message, {
          duration: TOAST_DURATION,
          position: TOAST_POSITION,
          style: {
            color: TOAST_SUCCESS_COLOR,
          },
        });
      } else {
        switch (logout.status_code) {
          case 402:
            toast.error(logout.message, {
              duration: TOAST_DURATION,
              position: TOAST_POSITION,
              style: {
                color: TOAST_ERROR_COLOR,
              },
            });
            break;
          default:
        }
      }
    }
  }, [logout]);

  useEffect(() => {
    if (AdminLogout !== null) {
      dispatch(resetAdminLogoutResponse());
      if (AdminLogout.status === true) {
        localStorage.clear();
        navigate("/login", { replace: true });
        toast.success(AdminLogout.message, {
          duration: TOAST_DURATION,
          position: TOAST_POSITION,
          style: {
            color: TOAST_SUCCESS_COLOR,
          },
        });
      } else {
        switch (AdminLogout.status_code) {
          case 402:
            toast.error(AdminLogout.message, {
              duration: TOAST_DURATION,
              position: TOAST_POSITION,
              style: {
                color: TOAST_ERROR_COLOR,
              },
            });
            break;
          default:
        }
      }
    }
  }, [AdminLogout]);

  useEffect(() => {
    if (EmployerLogout !== null) {
      dispatch(resetEmployerLogoutResponse());
      if (EmployerLogout.status === true) {
        localStorage.clear();
        navigate("/login", { replace: true });
        toast.success(EmployerLogout.message, {
          duration: TOAST_DURATION,
          position: TOAST_POSITION,
          style: {
            color: TOAST_SUCCESS_COLOR,
          },
        });
      }
      else {
        switch (EmployerLogout.status_code) {
          case 402:
            toast.error(EmployerLogout.message, {
              duration: TOAST_DURATION,
              position: TOAST_POSITION,
              style: {
                color: TOAST_ERROR_COLOR,
              },
            });
            break;
          default:
        }
      }
    }
  }, [EmployerLogout]);

  useEffect(() => {
    if (EmployeeLogout !== null) {
      dispatch(resetEmployeeLogoutResponse());
      if (EmployeeLogout.status === true) {
        localStorage.clear();
        navigate("/login", { replace: true });
        toast.success(EmployeeLogout.message, {
          duration: TOAST_DURATION,
          position: TOAST_POSITION,
          style: {
            color: TOAST_SUCCESS_COLOR,
          },
        });
      } else {
        switch (EmployeeLogout.status_code) {
          case 402:
            toast.error(EmployeeLogout.message, {
              duration: TOAST_DURATION,
              position: TOAST_POSITION,
              style: {
                color: TOAST_ERROR_COLOR,
              },
            });
            break;
          default:
        }
      }
    }
  }, [EmployeeLogout]);

  const renderFirstletter = (item) => {
    const str = item;
    const str2 = str?.charAt(0);
    return str2?.toUpperCase();
  };

  const renderLatestNotification = () => {
    var latestNotification = [];

    latestNotificationList != null &&
      latestNotificationList.data != null &&
      latestNotificationList.data.length > 0 ? (
      latestNotificationList.data.map((item, index) => {
        latestNotification.push(
          <li>
            <a
              className={`dropdown-item text-decoration-none ${item.readed === 0 ? "unread" : ""
                }`}
            >
              <div className="py-1">
                <p className="mb-1">
                  <b>{item.title}</b>
                </p>
                <p className="mb-1 text-white text-wrap fs-7">
                  {item.notification}
                </p>
                <p className="small text-primary mb-0">
                  {timeSince(item.created_at)}
                </p>
              </div>
            </a>
          </li>
        );
      })
    ) : (
      <></>
    );
    return latestNotification;
  };

  const closeNavbar = () => {
    const navbar = document.getElementById("collapsibleNavbar");
    if (navbar?.classList.contains("show")) {
      const bsCollapse = window.bootstrap.Collapse.getInstance(navbar) || new window.bootstrap.Collapse(navbar, { toggle: false });
      bsCollapse.hide();
    }
  };
  const handleLogoClick = () => {
    // if user logged in then in case of employer or employees navigate to diff dashboard
    if (!!user) {
      navigate(
        employer == "employerdashboard" || employer == "copsdashboard"
          ? "/employer/employees"
          : "/policies",
        {
          replace: true,
        }
      );
    }
  };

  return (
    <>
      {/* BEGIN: Header*/}
      <header className="">
        <div className="fixed-top ">
          {/*START top header */}
          {/* navbar */}
          {/* <nav>
            <div className="d-flex justify-content-between border-bottom bg-white">
              <a
                className="navbar-brand pt-0"
                onClick={handleLogoClick}
              >
                <img
                  className="w-156"
                  src={`${SUB_DIRECTORY}/assets/images/Axis_Bank-Logo.png`}
                  title=""
                  alt="logo"
                />
              </a>
            </div>
          </nav> */}
          <img className="w-100 header-bg" src={`${SUB_DIRECTORY}/assets/images/nav.png`} />
          <div className="bg-white bg-nav">
            <nav className="navbar navbar-expand-md  navbar-dark py-3 cust-shadow-sm cust-mt-1-6 main-navbar  gallery-cropper">
              <div className=" container-fluid py-0">
                <a className="navbar-brand pt-0 mt-2" onClick={handleLogoClick}>
                  <img
                    className="w-156"
                    src={logo}
                    title=""
                    alt="logo"
                  />
                </a>
                {user != null ? (
                  <>
                    <button
                      className="navbar-toggler text-dark collapsed"
                      type="button"
                      aria-label="collapsebtn"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapsibleNavbar"
                      aria-expanded="false"
                    >
                      <span class="navbar-toggler-icon text-white"></span>
                    </button>
                    <div
                      className="navbar-collapse collapse show"
                      id="collapsibleNavbar"
                    >
                      <ul className="navbar-nav  justify-content-center">
                        {/* <ul className={`navbar-nav ${employer == "employeedashboard" ? "justify-content-center" : "ms-auto "}`}> */}
                        {(employer != "employeedashboard" && ENV === 'prod') && (
                          <li>
                            <div className="dropdown-divider d-block d-lg-none d-md-none" />
                            <NavLink
                              to="/employer/dashboard"
                              onClick={closeNavbar}

                              className={({ isActive }) =>
                                isActive
                                  ? "nav-link text-white activeroute"
                                  : "nav-link text-white "
                              }
                            >
                              Dashboard
                            </NavLink>
                          </li>
                        )}
                        {employer != "employeedashboard" && (
                          <>
                            {/* employer */}

                            {/* employer2 */}
                            <li>
                              <NavLink
                                to="/employer/policies"
                                onClick={closeNavbar}

                                className={({ isActive }) =>
                                  isActive
                                    ? "nav-link text-white activeroute"
                                    : "nav-link text-white"
                                }
                              >
                                Policy List
                              </NavLink>
                            </li>
                          </>
                        )}
                        {/* employer4 */}{
                          (employer != "employeedashboard" && ENV === 'prod') &&
                          <li>
                            <NavLink
                              to="/employer/quotes"
                              onClick={closeNavbar}

                              className={({ isActive }) =>
                                isActive
                                  ? "nav-link text-white activeroute"
                                  : "nav-link text-white"
                              }
                            >
                              Quote List
                            </NavLink>
                          </li>
                        }
                        {employer != "employeedashboard" && (
                          <>
                            <li>
                              <NavLink
                                onClick={closeNavbar}
                                to="/employer/endorsments"
                                className={({ isActive }) =>
                                  isActive
                                    ? "nav-link text-white activeroute"
                                    : "nav-link text-white"
                                }
                              >
                                Endorsment List
                              </NavLink>
                            </li>
                            {/* employer 3*/}

                            <li>
                              <div className="dropdown-divider d-block d-lg-none d-md-none" />
                              <NavLink
                                onClick={closeNavbar}
                                to="/employer/claims"
                                className={({ isActive }) =>
                                  isActive
                                    ? "nav-link text-white activeroute"
                                    : "nav-link text-white "
                                }
                              >
                                Claim List
                              </NavLink>
                              <div className="dropdown-divider d-block d-lg-none d-md-none" />
                            </li>

                          </>)}
                        {/* employer5 */}
                        {(employer == "copsdashboard" || employer == "superuserdashboard") && (
                          <li>
                            <NavLink
                              onClick={closeNavbar}
                              to="/employer/cd-balance"
                              className={({ isActive }) =>
                                isActive
                                  ? "nav-link text-white activeroute"
                                  : "nav-link text-white"
                              }
                            >
                              CD Balance List
                            </NavLink>
                          </li>
                        )}
                        {(employer != "employeedashboard") && (
                          <>
                            <li>
                              <NavLink
                                onClick={closeNavbar}
                                to="/employer/task-panel"
                                className={({ isActive }) =>
                                  isActive
                                    ? "nav-link text-white activeroute"
                                    : "nav-link text-white"
                                }
                              >
                                Admin Task
                              </NavLink>
                            </li>

                            <li>
                              <div className="dropdown-divider d-block d-lg-none d-md-none" />
                              <NavLink
                                to="/employer/employees"
                                onClick={closeNavbar}
                                className={({ isActive }) =>
                                  isActive
                                    ? "nav-link text-white activeroute"
                                    : "nav-link text-white "
                                }
                              >
                                Employee List
                              </NavLink>
                              <div className="dropdown-divider d-block d-lg-none d-md-none" />
                            </li>
                          </>
                        )}
                        {(employer == "copsdashboard" || employer == "superuserdashboard") && (
                          <>
                            <li>
                              <div className="dropdown-divider d-block d-lg-none d-md-none" />
                              <NavLink
                                to="/employer/list"
                                onClick={closeNavbar}
                                className={({ isActive }) =>
                                  isActive
                                    ? "nav-link text-white activeroute"
                                    : "nav-link text-white "
                                }
                              >
                                Employer List
                              </NavLink>
                              <div className="dropdown-divider d-block d-lg-none d-md-none" />
                            </li>
                          </>
                        )}
                        {employer == "employeedashboard" && (
                          <>
                            <li className="nav-item">
                              <NavLink
                                to="/policies"
                                onClick={closeNavbar}
                                className={({ isActive }) =>
                                  isActive
                                    ? "nav-link text-white activeroute"
                                    : "nav-link text-white "
                                }
                              >
                                Policies
                              </NavLink>
                              <div className="dropdown-divider d-block d-lg-none d-md-none" />
                            </li>
                            {/* <li className="nav-item">
                          <NavLink
                            to="/other_quote_list"
                            className={({ isActive }) =>
                              isActive
                                ? "nav-link text-white activeroute"
                                : "nav-link text-white "
                            }
                          >
                            Quote
                          </NavLink>
                        </li> */}
                            <li className="nav-item pr-0">
                              <NavLink
                                onClick={closeNavbar}
                                to={{
                                  pathname: "/new-vehicle",
                                  state: user,
                                }}
                                className={({ isActive }) =>
                                  isActive
                                    ? "nav-link text-white activeroute"
                                    : "nav-link text-white "
                                }
                              >
                                New / Personal Vehicle
                              </NavLink>
                              <div className="dropdown-divider d-block d-lg-none d-md-none" />
                            </li>
                            <li className="nav-item">
                              <NavLink
                                onClick={closeNavbar}
                                to="/claim"
                                className={({ isActive }) =>
                                  isActive
                                    ? "nav-link text-white activeroute"
                                    : "nav-link text-white "
                                }
                              >
                                Claim
                              </NavLink>
                              <div className="dropdown-divider d-block d-lg-none d-md-none" />
                            </li>
                            <li className="nav-item">
                              <a
                                class="nav-link text-white "
                                href="//tataaig.com/locator/cashless-car-network-garages"
                                target="_blank"
                              >
                                Cashless Garage
                              </a>
                              <div className="dropdown-divider d-block d-lg-none d-md-none" />
                            </li>
                          </>
                        )}
                        <li className="nav-item pr-0 d-block d-md-none">

                          <NavLink
                            to="/my-profile"
                            onClick={closeNavbar}
                            className={({ isActive }) =>
                              isActive ? "dropdown-item" : "dropdown-item show"
                            }
                          >
                            My Profile
                          </NavLink>
                          <div className="dropdown-divider d-block d-lg-none d-md-none" />
                        </li>

                        {employer != "employeedashboard" && (
                          <li>
                            <NavLink
                              to="/employer/contact-details"
                              onClick={closeNavbar}
                              className={({ isActive }) =>
                                isActive
                                  ? "nav-link text-white activeroute"
                                  : "nav-link text-white"
                              }
                            >
                              Contact Details
                            </NavLink>
                          </li>
                        )}

                        <li className="nav-item pr-0 d-block d-md-none">
                          <a
                            className={`nav-link text-white ${route === "/my-profile" ? "activeroute" : ""
                              }`}
                            onClick={async () => {
                              // Dispatch without params - the post helper will handle the token
                              if (employer == "copsdashboard" || employer == "superuserdashboard") {
                                dispatch(actionAdminLogout({})); // Pass empty object or null
                              } else if (employer == "employerdashboard") {
                                dispatch(actionEmployerLogout({}));
                              } else if (employer == "employeedashboard") {
                                dispatch(actionEmployeeLogout({}));
                              }
                            }}

                          >
                            Logout
                          </a>
                          <div className="dropdown-divider d-block d-lg-none d-md-none" />
                        </li>
                        <li className="nav-item dropdown d-none d-md-block">
                          <a
                            className={`${route === "/my-profile"
                              ? "nav-link  text-white show activeroute"
                              : "nav-link text-white"
                              }`}
                            data-bs-toggle="dropdown"
                            role="button"
                            aria-expanded="false"
                          >
                            <div className="nav-profile mx-auto">
                              {/* <img src={`${SUB_DIRECTORY}/assets/images/dummy.png`} alt="" /> */}
                              <div className="_name">
                                {renderFirstletter(
                                  userName != null ? userName : ""
                                )}
                              </div>
                            </div>
                          </a>
                          <ul className="dropdown-menu dropdown-menu-end">
                            <li>
                              <NavLink
                                to="/my-profile"
                                className={({ isActive }) =>
                                  isActive ? "dropdown-item" : "dropdown-item show"
                                }
                              >
                                My profile
                              </NavLink>
                            </li>
                            <li>
                              <hr className="dropdown-divider" />
                            </li>
                            {employer == "employerdashboard" ? (
                              <>
                                <li>
                                  <NavLink
                                    to="/employer-change-password"
                                    className={({ isActive }) =>
                                      isActive
                                        ? "dropdown-item"
                                        : "dropdown-item show"
                                    }
                                  >
                                    Change Password- Employer
                                  </NavLink>
                                </li>
                                <li>
                                  <hr className="dropdown-divider" />
                                </li>
                              </>
                            ) : employer == "copsdashboard" ? (
                              <>
                                <li>
                                  <NavLink
                                    to="/admin-change-password"
                                    className={({ isActive }) =>
                                      isActive
                                        ? "dropdown-item"
                                        : "dropdown-item show"
                                    }
                                  >
                                    Change Password-Admin
                                  </NavLink>
                                </li>
                                <li>
                                  <hr className="dropdown-divider" />
                                </li>
                              </>
                            ) : null}

                            <li>
                              <a
                                className="dropdown-item"
                                onClick={async () => {
                                  // Dispatch without params - the post helper will handle the token
                                  if (employer == "copsdashboard" || employer == "superuserdashboard") {
                                    dispatch(actionAdminLogout({})); // Pass empty object or null
                                  } else if (employer == "employerdashboard") {
                                    dispatch(actionEmployerLogout({}));
                                  } else if (employer == "employeedashboard") {
                                    dispatch(actionEmployeeLogout({}));
                                  }
                                }}
                              >
                                Logout
                              </a>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </div>
                  </>
                ) : (
                  <></>
                )}
              </div>
            </nav>
          </div>
        </div>
      </header>
      {/* END: Header*/}
    </>
  );
};

export default Header;
